// English is the source of truth. `Dict` in ./types is derived from this file,
// so fr/de/ar fail to compile if a key is missing or misspelled.
const en = {
  brand: { name: "SkillSynergy", first: "Skill", second: "Synergy" },

  nav: {
    courses: "Courses",
    pricing: "Pricing",
    about: "About",
    contact: "Contact",
    bookCall: "Book a free call",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    language: "Language",
    skipToContent: "Skip to content",
  },

  cta: {
    exploreCourses: "Explore courses",
    bookConsultation: "Book a free consultation",
    scheduleConsultation: "Schedule a free consultation",
    viewCourse: "View course",
    viewAll: "View all",
    comparePlans: "Compare all plans",
    getInTouch: "Get in touch",
    enrollNow: "Enroll now",
    seePricing: "See pricing",
    purchaseNow: "Purchase now",
    contactUs: "Contact us",
    done: "Done",
  },

  footer: {
    tagline: "Live, hands-on programming courses for every level.",
    coursesHeading: "Courses",
    contactHeading: "Get in touch",
    contactBody:
      "Questions about a course? We usually reply within one business day.",
    copyright: (year: number) =>
      `Copyright © ${year} SkillSynergy. All Rights Reserved.`,
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    imprint: "Imprint",
    cookieSettings: "Cookie settings",
    socialLabel: (network: string) => `SkillSynergy on ${network}`,
  },

  booking: {
    eyebrow: "Free consultation",
    title: "Let's map out your path in 30 minutes",
    body: "No pressure, no cost. We'll assess your level and recommend the right course and track.",
    benefits: [
      "A learning plan built around your goals",
      "Guidance from an expert instructor",
      "Answers on pricing, schedule and format",
    ],
    formTitle: "Book your free call",
    fullName: "Full name",
    fullNamePlaceholder: "Jane Doe",
    email: "Email",
    emailPlaceholder: "jane@email.com",
    courseOfInterest: "Course of interest",
    notSureYet: "Not sure yet",
    preferredTrack: "Preferred track",
    bestTime: "Best time to call",
    times: { morning: "Morning", afternoon: "Afternoon", evening: "Evening" },
    submit: "Request my free call",
    submitting: "Sending…",
    disclaimer:
      "We'll never share your details. Reply within one business day.",
    successTitle: "Request received",
    successBody:
      "Thanks, we'll email you within one business day to confirm your free consultation.",
    close: "Close",
    error: "That didn't go through. Please try again or email us directly.",
  },

  form: {
    required: "This field is required.",
    invalidEmail: "Enter a valid email address.",
    consentLabel: "I have read and agree to the",
    consentLink: "Privacy Policy",
    consentSuffix: "and consent to my details being used to answer my enquiry.",
    consentRequired: "Please accept the Privacy Policy to continue.",
    rateLimited:
      "You've sent this a few times already. Please wait a little before trying again.",
  },

  consent: {
    title: "We respect your privacy",
    body: "We use cookies that are strictly necessary to run this site. With your permission we'd also like to collect anonymous error reports so we can fix bugs faster. You can change your mind at any time.",
    acceptAll: "Accept all",
    rejectAll: "Reject non-essential",
    save: "Save choices",
    customise: "Customise",
    privacyLink: "Privacy Policy",
    imprintLink: "Imprint",
    categories: {
      necessary: {
        title: "Strictly necessary",
        body: "Required for the site to work: your language, your cookie choices and basic security. These never leave our servers.",
        always: "Always on",
      },
      analytics: {
        title: "Error reporting",
        body: "Loads Sentry, which reports crashes and errors so we can fix them. It receives your IP address and browser details.",
      },
    },
  },

  a11y: {
    previous: "Previous",
    next: "Next",
    breadcrumb: "Breadcrumb",
    home: "Home",
    newTab: "opens in a new tab",
  },
};

export default en;
